import React from "react";

type Props = {};

// eslint-disable-next-line no-empty-pattern
export default function RingNotificationIcon(props: Props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.053 20.8824C14.245 21.578 13.1836 22 12.0212 22C10.8588 22 9.79751 21.578 8.98951 20.8824M18.8936 13.261V9.70592C18.8936 5.99276 15.8282 3 12.0212 3C8.21427 3 5.10735 5.86517 5.10735 9.70592V13.2369C5.10735 13.7769 5.02106 14.3134 4.85179 14.8257L4.00559 17.3868C3.98242 17.4569 4.03416 17.5293 4.10743 17.5293H19.8857C19.9632 17.5293 20.0182 17.4557 19.9944 17.3838L19.1425 14.8053C18.9776 14.3063 18.8936 13.7852 18.8936 13.261Z"
        stroke="#111111"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
